interface SSIReportProps {
  report: string;
}

export default function SSIReport({ report }: SSIReportProps) {
  if (!report) return null;

  return (
    <section
      role="region"
      aria-label="Relatório de análise SSI"
      aria-live="polite"
      className="mt-10 bg-white border border-zinc-200 rounded-xl p-6 md:p-8"
    >
      <h2 className="font-sora font-bold text-xl text-zinc-900 mb-4">Relatório de Análise</h2>
      <div className="font-inter text-zinc-700 leading-relaxed whitespace-pre-wrap text-sm md:text-base">
        {report}
      </div>
    </section>
  );
}
